import Vue from 'vue';
import './bootstrap';
import 'jquery-ui/ui/widgets/datepicker.js'
import VueDatepicker from 'vuejs-datepicker'

import VueFuse from 'vue-fuse';
Vue.use(VueFuse);

import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);

import InfiniteMultiselect from './components/generic/InfiniteMultiselect.vue';
Vue.component('infinite-multiselect', InfiniteMultiselect);

/*******************************************************************
 * Initialize Ajax Defaults
 *******************************************************************/
const csrfToken = document.querySelector('#csrf-token');
if (csrfToken) {
    const token = csrfToken.getAttribute('content');

    Vue.http.headers.common['X-CSRF-TOKEN'] = token;

    $.ajaxSetup({
        headers : { 'X-CSRF-TOKEN': token }
    });
}

/*******************************************************************/

/*******************************************************************
 * Register View Components
 *******************************************************************/
Vue.config.productionTip = false;

//Generic Components
Vue.component('csrf-token', require('./components/csrf-token.vue'));
Vue.component('paytrace-payment', require('./components/paytrace-payment.vue'));
Vue.component('tutorialize', require('./components/tutorialize.vue'));
Vue.component('account-picker', require('./components/account-picker.vue'));
Vue.component('industry-picker', require('./components/industry-picker.vue'));
Vue.component('address-picker', require('./components/address/address-picker.vue'));
Vue.component('address-entry', require('./components/address/address-entry.vue'));
Vue.component('paginator', require('./components/paginator.vue'));
Vue.component('visible-user-picker', require('./components/visible-user-picker.vue'));
Vue.component('table-column-filter', require('./components/table-column-filter.vue'));
Vue.component('app-message-list', require('./components/app-message-list.vue'));
Vue.component('industry-help-me-picker', require('./components/industry-help-me-picker.vue'));
Vue.component('timeout-warning', require('./components/timeout-warning.vue'));
Vue.component('select-user-picker', require('./components/select-user-picker.vue'));
Vue.component('date-picker', VueDatepicker);
Vue.component('multi-select', require('./components/multi-select-list.vue'));
Vue.component('simple-table', require('./components/simple-table.vue'));
Vue.component('mwl-lab-contacts', require('./components/mwl-lab-contacts.vue'));
Vue.component('autocomplete', require('./components/auto-complete.vue'));
Vue.component('multi-select-ex', require('./components/multi-select-ex.vue'));
Vue.component('dashboard-banners', require('./components/dashboard-banners.vue'));

// Transitions
Vue.component('transition-staggered-list', require('./components/transition-staggered-list.vue'));

//Page Specific Components
Vue.component('supply', require('./components/supply.vue'));
Vue.component('supply-kit-analysis-order', require('./components/supply-kit-analysis-order.vue'));
Vue.component('checkout-card', require('./components/checkout-card.vue'));
Vue.component('checkout-add-card', require('./components/checkout-add-card.vue'));
Vue.component('checkout-update-card', require('./components/checkout-update-card.vue'));
Vue.component('account-list-item', require('./components/account-list-item.vue'));
Vue.component('account-list', require('./components/account-list.vue'));
Vue.component('visible-user-list', require('./components/visible-user-list.vue'));
Vue.component('visible-user-list-item', require('./components/visible-user-list-item.vue'));
Vue.component('document-list-standard-view', require('./components/documents/document-list-standard-view.vue'));
Vue.component('document-list-results-view', require('./components/documents/document-list-results-view.vue'));
Vue.component('document-item', require('./components/documents/document-item.vue'));
Vue.component('document-list', require('./components/documents/document-list.vue'));
Vue.component('grid-settings', require('./components/grid-settings.vue'));
Vue.component('dynamic-table', require('./components/dynamic-table.vue'));
Vue.component('table-item', require('./components/table-item.vue'));
Vue.component('shipping-label-item', require('./components/shipping-label-item.vue'));
Vue.component('shipping-label-carrier', require('./components/shipping-label-carrier.vue'));
Vue.component('account-role-item', require('./components/account-role-item.vue'));
Vue.component('sys-admin-account-role-list', require('./components/sys-admin-account-role-list.vue'));
Vue.component('sys-admin-user-list-item', require('./components/sys-admin-user-list-item.vue'));
Vue.component('admin-account-list-item', require('./components/admin-account-list-item.vue'));
Vue.component('admin-user-role-list', require('./components/admin-user-role-list.vue'));
Vue.component('account-preferences', require('./components/account-preferences.vue'));
Vue.component('my-account-role-list', require('./components/account-roles/my-account-role-list.vue'));
Vue.component('account-password-add', require('./components/account-password-add.vue'));
Vue.component('user-notification-list', require('./components/user-notification-list.vue'));
Vue.component('report-totals-chart', require('./components/report-totals-chart.vue'));
Vue.component('change-list', require('./components/change-list.vue'));
Vue.component('online-soil-report', require('./components/online-soil-report.vue'));
Vue.component('soil-recs-modal', require('./components/soil-recs-modal.vue'));
Vue.component('payment-entry-interface', require('./components/payments-entry-interface.vue'));
Vue.component('sharedinsights-account-list-item', require('./components/shared_insights/sharedinsights-account-list-item.vue'));
Vue.component('sharedinsights-download-form', require('./components/shared_insights/sharedinsights-download-form.vue'));
Vue.component('first-account-selection', require('./components/account-roles/first-account-selection.vue'));
Vue.component('address-valid-selector', require('./components/address/address-valid-selector.vue'));
Vue.component('document-column-settings-modal', require('./components/documents/document-column-settings-modal.vue'));
Vue.component('getting-started', require('./components/resources.vue'));
Vue.component('package-multi-select', require('./components/documents/package-multi-select.vue'));
Vue.component('sample-type-multi-select', require('./components/documents/sample-type-multi-select.vue'));
Vue.component('safety-data-sheet-list', require('./components/documents/safety-data-sheet-list.vue'));
Vue.component('add-safety-data-sheet', require('./components/documents/add-safety-data-sheet.vue'));
Vue.component('submission-draft-table', require('./components/submission-draft-table.vue'));
Vue.component('dashboard-banners-admin', require('./admin/dashboard-banners-admin.vue'));

/*******************************************************************/

// require('./functions.js');
require('./DOMInitialization.js');
require('./nav.js');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js